import { config } from '@/config';

/**
 * Страница входа. Пока – заглушка-точка входа: реальный вход делегируется
 * SSO-сервису (local.auth.org) либо будет заменён формой, работающей через
 * BFF (/api/auth/login). Оставлено как явное место для переноса Orchid-логина.
 */
export function LoginPage() {
  return (
    <section className="gate">
      <h1>Вход в админ-панель</h1>
      <p className="gate__lede">
        Аутентификация выполняется через сервис единого входа. Здесь появится форма/редирект,
        заменяющие Orchid-логин старой админки.
      </p>
      <a className="btn btn--primary" href={config.loginUrl}>
        Перейти ко входу ({config.loginUrl})
      </a>
    </section>
  );
}
